<template>
  <div class="study-rule" v-show="ruleShow">
    <div class="rule-mask"></div>
    <div class="rule-content">
      <i class="iconfont icon-close icon" @click="handleCloseRule"></i>
      <div>
        <p>1、直播或点播，观看20分钟以上记学时，低于20分钟不记学时。</p>
        <p>2、直播中途退出后再进入，观看时间继续累加。</p>
        <p>3、直播与点播分别记学时，发放学时二取一，以最高为准，不超过课程总学时。</p>
        <p>4、系统自动记录观看数据，不需在留言区回复"打卡"，"签到"等词语。</p>
        <p>5、观看直播或录播时长至少到课程总时长的一半才能申请证书。</p>
        <p>6、一堂课只能申请一次学时证书。</p>
        <p>7、只有观看本学科的课程，才能申请学时证书。</p>
        <p>8、如果对学时有异议，可先至"观看记录"页面查询，更多异议请联系工作人员。</p>
        <p>9、最后一次观看的24小时之后才能申请学时，申请后等待审核发放！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'study-rule',
  props: {
    ruleShow: {
      type: Boolean
    }
  },
  methods: {
    handleCloseRule() {
      this.$emit('CloseRule')
    }
  }
}
</script>

<style lang="scss" scoped>
.study-rule {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  .rule-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 5, 26, 0.4);
  }
  .rule-content {
    position: absolute;
    left: 10%;
    top: 50%;
    width: 80%;
    transform: translateY(-50%);
    padding: 36px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 12px;
    z-index: 101;
    .icon {
      position: absolute;
      right: 12px;
      top: 12px;
    }
    h3 {
      margin-bottom: 16px;
      color: #303133;
      font-weight: 700;
      text-align: center;
    }
    p {
      margin-bottom: 12px;
      color: #303133;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>
